module.exports = function getResource(label, vars = []) {
    let resources = {
        map: 'Plan',
        moreTimesLocations: 'Afficher plus d’heures et d’emplacements'
    };

    return resources[label];
};
